<template>
  <b-modal ref="mc-modal" size="md" centered scrollable :title="$t('global.action.changeStatus')">
    <div class="card-body p-2">
      <p
        v-html="
          $t('fleetTask.cancelModal.confirmationText', {
            number: entityData.number,
          })
        "
      />

      <p>{{ $t('fleetTask.cancelModal.alertText') }}</p>

      <FormulateForm
        v-model="formValues"
        name="reason-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          v-if="hasFeatureFleetTaskContractMGM"
          type="select-resourceful"
          name="canceled-category-id"
          trackBy="id"
          validation="required"
          :label="$t('fleetTask.cancelModal.field.cancellationCategory')"
          :placeholder="$t('fleetTask.cancelModal.placeholder.cancellationCategory')"
          :help="true"
          :optionLabelFn="({ item }) => item.name"
          :optionsGetter="getCancelCategoryOptions"
          :validation-messages="{
            required: $t('global.validation.required'),
          }"
        />
        <FormulateInput
          type="select-resourceful"
          name="reason-id"
          trackBy="id"
          validation="required"
          :label="$t('fleetTask.cancelModal.field.cancelReason')"
          :placeholder="$t('fleetTask.cancelModal.placeholder.cancelReason')"
          :help="true"
          :optionLabelFn="({ item }) => item.reason"
          :optionsGetter="reasonGet"
          :validation-messages="{
            required: $t('global.validation.required'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton
          @click="cancel"
          variant="secondary"
          :text="`${$t('global.no')}, ${$t('global.back')}`"
        />
        <McButton @click="triggerSubmit" :text="$t('global.action.confirmCancel')" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import McButton from '@/components/McButton'

import * as Reason from '@/services/rest-api/lib/fleet-task/reason'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],
  props: {
    entityData: {
      required: true,
    },
    newStatusTransition: {
      required: true,
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'CANCELED'"),
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasFeatureFleetTaskContractMGM() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data?.features?.fleet_task_contract
      )
    }
  },
  methods: {
    getCancelCategoryOptions() {
      return {
        metadata: {
          count: 2,
          page: 1,
          total_count: 2,
          total_page: 1,
        },
        data: {
          paginated_result: [
            {
              id: 'CHARGE',
              name: this.$t('fleetTask.cancelModal.option.charge'),
            },
            {
              id: 'NON_CHARGE',
              name: this.$t('fleetTask.cancelModal.option.nonCharge'),
            },
          ],
        },
      }
    },
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit(data) {
      this.$emit('transition', {
        transition: this.newStatusTransition,
        additionalPayload: {
          fields: {
            canceled_category: this.hasFeatureFleetTaskContractMGM ? data['canceled-category-id'] : undefined,
            canceled_reason_id: data['reason-id'],
            cancel_delivery_order: this.hasFeatureFleetTaskContractMGM ? true : undefined,
          },
        },
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    // NOTE:
    // This function will be called from parents,
    // Ideally we capitalized the first letter of the function name
    // but the name are kept as 'show' and 'hide' to match bootstrap's convention
    // of modal 'show' and 'hide' function
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: 600;
}
</style>
